import React from 'react';
import styles from './ArticleDetailPage.module.css';
import { HeroSection } from './HeroSection';
import { IntroSection } from './IntroSection';
import { ContentBlock } from './ContentBlock';
import { CTASection } from './CTASection';
import ConsultationBanner from '@/components/report/tabs/ConsultationBanner';
import { ArticleData } from './types';

interface ArticleDetailPageProps {
    data: ArticleData;
}

export const ArticleDetailPage: React.FC<ArticleDetailPageProps> = ({ data }) => {
    const { hero, introSection, contentBlocks, ctaSections } = data;

    return (
        <div className={styles.articlePage}>
            {/* Hero Header */}
            <HeroSection data={hero} />

            {/* Introduction Section */}
            <IntroSection data={introSection} />

            {/* Content Blocks */}
            {contentBlocks.map((block) => (
                <React.Fragment key={block.id}>
                    <ContentBlock data={block} />
                    {data.interleavedCTAs && data.interleavedCTAs[block.id] && (
                        <>
                            {data.interleavedCTAs[block.id].customComponent === 'consultation-banner' ? (
                                <div className={styles.bannerContainer}>
                                    <ConsultationBanner
                                        text={data.interleavedCTAs[block.id].text}
                                        buttonText={data.interleavedCTAs[block.id].buttonText}
                                        buttonLink={data.interleavedCTAs[block.id].buttonLink}
                                    />
                                </div>
                            ) : (
                                <CTASection data={data.interleavedCTAs[block.id]} />
                            )}
                        </>
                    )}
                </React.Fragment>
            ))}

            {/* CTA Sections (End of article) */}
            {ctaSections && ctaSections.map((cta, index) => (
                <CTASection key={index} data={cta} />
            ))}
        </div>
    );
};
